module.exports = __webpack_public_path__ + "static/media/Laidley Street, San Francisco, CA8.b142ccec.jpg";